export default "//yastatic.net/s3/distribution/pythia/frontend/_/5ed047ff74f68b6d536a6c4b3b33b97d.svg";